import axios from 'axios';
import { ApiResponse } from '../api/models/common';
import {
  FeedbackPayload,
  FeedbackHistoryParams,
  FeedbackHistoryRawItem,
  PageData,
} from '../api/models/feedback';

export const feedbackService = {
  /**
   * Submit feedback (multipart/form-data for images).
   */
  submitFeedback: async (payload: FeedbackPayload, images: File[]) => {
    const formData = new FormData();
    formData.append('content', payload.content);
    formData.append('deviceId', payload.deviceId);
    if (payload.contact) formData.append('contact', payload.contact);
    if (payload.userId) formData.append('userId', String(payload.userId));
    images.forEach(img => formData.append('images', img));

    const response = await axios.post<ApiResponse<void>>('feedbacks', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Get feedback history (paginated).
   * - Logged-in user → by userId
   * - Anonymous → by deviceId
   */
  getFeedbackHistory: async (params: FeedbackHistoryParams) => {
    const response = await axios.get<ApiResponse<PageData<FeedbackHistoryRawItem>>>('feedbacks/history', {
      params: {
        deviceId: params.deviceId,
        userId: params.userId,
        page: params.page ?? 0,
        size: params.size ?? 20,
      },
    });
    return response.data;
  },
};
